import { ArrowDownRight, ArrowUpRight, Minus } from "lucide-react";

// Grille de statistiques : bord à bord, sans carte colorée. Une console n'est
// pas un tableau de bord marketing.
export function StatGrid({ children }) {
  return <div className="adm-stats">{children}</div>;
}

function Delta({ value, label }) {
  if (value === null || value === undefined) return null;
  const tone = value > 0 ? "up" : value < 0 ? "down" : "flat";
  const Icon = value > 0 ? ArrowUpRight : value < 0 ? ArrowDownRight : Minus;
  const formatted = `${value > 0 ? "+" : ""}${value}${typeof value === "number" ? " %" : ""}`;
  return (
    <span className={`adm-delta is-${tone}`}>
      <Icon size={12} />{formatted}{label && <span style={{ fontWeight: 400, color: "var(--adm-ink-3)" }}> {label}</span>}
    </span>
  );
}

/* `unavailable` couvre le cas honnête : la mesure n'existe pas encore.
   On affiche « Pas encore mesuré » plutôt qu'un zéro qui ferait croire à une
   valeur réelle. */
export default function StatCard({
  label, value, unit, delta = null, deltaLabel, hint, spark, icon: Icon,
  href, onClick, unavailable = false, unavailableText = "Pas encore mesuré", testid,
}) {
  const Tag = href ? "a" : onClick ? "button" : "div";
  const props = href ? { href } : onClick ? { type: "button", onClick } : {};
  const max = spark?.length ? Math.max(...spark, 1) : 1;
  return (
    <Tag className={`adm-stat${unavailable ? " is-unavailable" : ""}`} data-testid={testid} {...props}>
      <span className="adm-stat-label">{Icon && <Icon size={13} />}{label}</span>
      <div className="adm-stat-value">
        {unavailable ? unavailableText : <>{value}{unit && <small>{unit}</small>}</>}
      </div>
      {!unavailable && (delta !== null || hint) && (
        <div className="adm-stat-foot">
          <Delta value={delta} label={deltaLabel} />
          {hint && <span>{hint}</span>}
        </div>
      )}
      {!unavailable && spark?.length > 0 && (
        <div className="adm-spark" aria-hidden="true">
          {spark.map((v, i) => <i key={i} style={{ height: `${Math.max(8, (v / max) * 100)}%` }} />)}
        </div>
      )}
      {unavailable && hint && <div className="adm-stat-foot"><span>{hint}</span></div>}
    </Tag>
  );
}
